import React, { useState } from 'react';
import { Play, Loader2 } from 'lucide-react';
import { generateSpeech } from '../services/text-to-speech';

interface TextToSpeechProps {
  text: string;
}

export function TextToSpeech({ text }: TextToSpeechProps) {
  const [loading, setLoading] = useState(false);
  const [audioUrl, setAudioUrl] = useState<string | null>(null);
  const audioRef = React.useRef<HTMLAudioElement | null>(null);

  const handlePlay = async () => {
    try {
      if (audioUrl) {
        audioRef.current?.play();
        return;
      }

      setLoading(true);
      const url = await generateSpeech(text);
      setAudioUrl(url);
      
      // Create and play audio
      const audio = new Audio(url);
      audioRef.current = audio;
      await audio.play();

      // Cleanup URL when audio ends
      audio.onended = () => {
        URL.revokeObjectURL(url);
        setAudioUrl(null);
      };
    } catch (error) {
      console.error('Failed to play audio:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={handlePlay}
      disabled={loading}
      className="w-8 h-8 rounded-full bg-blue-50 hover:bg-blue-100 flex items-center justify-center transition-colors"
    >
      {loading ? (
        <Loader2 className="w-4 h-4 text-blue-700 animate-spin" />
      ) : (
        <Play className="w-4 h-4 text-blue-700" />
      )}
    </button>
  );
}